import React, {useEffect, useState} from "react";
import {
    Dialog,
} from "@headlessui/react";
import {ArrowDownTrayIcon} from "@heroicons/react/24/outline";

import {useDispatch, useSelector} from "react-redux";
import type {RootState} from "../Store";
import Loader from "../components/Loader";
import {showPayment} from "../components/Utils";
import {setupWebSocket} from "../components/Websocket";
import {Store} from "../Store";

type Inputs = {
    qty: number;
};

const User = () => {
    const dispatch = useDispatch();

    const data = useSelector((state: RootState) => state);
    const clientId = localStorage.getItem("customer_id");

    let [empty, setEmpty] = useState(false);

    function dateFormat(date: any) {

        return new Date(date).toLocaleString("en-US", {
            month: "short", // Jan, Feb, Mar, etc.
            day: "numeric", // 1, 2, 3, etc.
            year: "numeric", // 2022, 2023, etc.
            hour: "numeric", // 12-hour format
            minute: "numeric", // Minutes
            hour12: true, // Use AM/PM
        })

    }

    useEffect(() => {

        if (data.user.detail.name) {
            setEmpty(true);
        }

    }, [data.user]);

    return (
        <>

            {empty == false && <Loader/>}

            {empty == true &&
                <div className="p-6">
                    <div className="space-y-4">

                        <div className="rounded-xl p-4">

                            <div className="text-ml font-semibold text-gray-900 w-full text-left">
                                {data.user.detail.name}
                            </div>
                            <div className="text-ml font-semibold text-gray-900 w-full text-left">
                                {data.user.detail.email}
                            </div>

                        </div>


                        <div className="flex flex-row bg-gray-100 rounded-xl p-4">

                            <div className="text-2xl font-semibold text-gray-900 w-2/4 text-left">
                                Credit
                            </div>

                            <div className="text-2xl font-semibold text-gray-900 w-2/4 text-right">${data.user.credit.toFixed(2)}</div>

                        </div>

                    </div>
                </div>

            }

            {empty == true &&
                <div className="p-6">
                    <div className="space-y-4">

                        <h4 className="text-2xl font-semibold text-gray-900 ">
                            Payment History
                        </h4>

                        {data.payment.items.length > 0 &&
                            data.payment.items.map((item: any, indx: number) => (
                                item.payment_type === "payment" && (
                                    <div
                                        key={indx}
                                        className={`flex flex-col bg-white border border-gray-300 rounded-xl p-4`}
                                    >
                                        <div className="space-y-2">
                                            <div className="flex items-center justify-between gap-3">
                                                <div className={`w-1/3 text-gray-600 font-bold ${item.payment_method == -1 ? 'credit-color' : 'stripe-color'}`}>
                                                    {showPayment(item.payment_method)}
                                                </div>
                                                <div className="w-1/3 text-left text-gray-400 text-sm">
                                                    {dateFormat(item.date)}
                                                </div>
                                                <div className="w-1/3 text-right font-bold text-gray-600 red-color">
                                                    - ${item.payment_amount.toFixed(2)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ) || item.payment_type === "credit" && (
                                    <div
                                        key={indx}
                                        className={`flex flex-col bg-white border border-gray-300 rounded-xl p-4`}
                                    >
                                        <div className="space-y-2">
                                            <div className="flex items-center justify-between gap-3">
                                                <div className={`w-1/3 text-gray-600 font-bold`}>
                                                    {showPayment(item.payment_method)}
                                                </div>
                                                <div className="w-1/3 text-left text-gray-400 text-sm">
                                                    {dateFormat(item.date)}
                                                </div>
                                                <div className="w-1/3 text-right font-bold text-gray-600 green-color">
                                                    + ${item.payment_amount.toFixed(2)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            ))
                        }
                    </div>
                </div>

            }


        </>
    );
};

export default User;
